import { useReducer } from "react"

const initialState = {
    anyLoading: false,
    data: {
        parametros: {},
    },
    error: {
        parametros: {
            isError: false,
            errorMessage: "",
        },
    },
    loading: {
        parametros: false,
    },
}

function reducer(state, action) {
    switch (action.type) {
        case "SET_LOADING": {
            const newLoading = { ...state.loading, [action.key]: action.payload }
            const anyLoading = Object.values(newLoading).some(Boolean)
            return { ...state, loading: newLoading, anyLoading }
        }
        case "SET_DATA":
            return {
                ...state,
                data: { ...state.data, [action.key]: action.payload },
                error: { ...state.error, [action.key]: { isError: false, errorMessage: "" } },
            }
        case "SET_ERROR":
            return {
                ...state,
                error: { ...state.error, [action.key]: action.payload },
            }
        default:
            return state
    }
}

export const useParameterMotor = (emissaoService, rendaFixaCaracteristicaID) => {
    const [state, dispatch] = useReducer(reducer, initialState)

    const loadParametros = async (idParam) => {
        const idConsulta = idParam ?? rendaFixaCaracteristicaID

        if (!idConsulta || idConsulta === "") {
            dispatch({
                type: "SET_ERROR",
                key: "parametros",
                payload: {
                    isError: true,
                    errorMessage: "empty rendaFixaCaracteristicaID value received",
                },
            })
            return
        }

        dispatch({ type: "SET_LOADING", key: "parametros", payload: true })

        try {
            const response = await emissaoService.getParametros(idConsulta)
            const parametrosList = response?.body?.Parametros ?? response?.Parametros ?? []

            dispatch({
                type: "SET_DATA",
                key: "parametros",
                payload: { Parametros: parametrosList },
            })
            return parametrosList[0]
        } catch (e) {
            const errorMessage = e?.message || e?.error || (typeof e === "string" ? e : "Erro ao carregar parâmetros")
            dispatch({
                type: "SET_ERROR",
                key: "parametros",
                payload: { isError: true, errorMessage },
            })
        } finally {
            dispatch({
                type: "SET_LOADING",
                key: "parametros",
                payload: false,
            })
        }
    }

    return {
        state,
        actions: {
            loadParametros,
        },
    }
}